module.exports = __webpack_public_path__ + "static/media/lnmiit.c004aaf6.png";